import * as React from 'react';
import styled from 'styled-components';

import { IconSystemV2ArrowArrowRightLine } from '@doltech/icons/SystemV2/IconSystemV2ArrowArrowRightLine';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';

const Container = styled.div`
  display: inline;

  .question-order-icon,
  .question-order-text {
    display: inline;
    vertical-align: middle;
  }
`;

interface QuestionNumberInlineItemProps {
  order?: number;
}

export const QuestionNumberInlineItem = (props: QuestionNumberInlineItemProps) => {
  const { order } = props;

  return (
    <Container className="question-number-inline-item">
      <ResponsiveTypography.Text
        className="question-order-text"
        variant="bold/16-24"
        color="blue100"
        mr="2px"
      >
        {order}
      </ResponsiveTypography.Text>
      <IconSystemV2ArrowArrowRightLine className="question-order-icon" size={16} color="blue60" />
    </Container>
  );
};
